export default __webpack_public_path__ + "static/media/500-internal-server-error-amico.c6144350.svg";